import { StatusCodes } from 'http-status-codes';

export const generateFileUploadToS3BucketErrorResponse = (
  statusCode: unknown,
  name: string = '',
): string => {
  let errorMessage = '';

  if (statusCode === StatusCodes.NOT_FOUND) {
    errorMessage = `Uploading files not found on AWS S3 ${name}.`;
  } else if (statusCode === StatusCodes.BAD_REQUEST) {
    errorMessage = `Failure to process request on AWS S3 ${name}.`;
  } else if (statusCode === StatusCodes.UNAUTHORIZED) {
    errorMessage = `You are unauthorized to upload files on AWS S3 ${name}.`;
  } else if (statusCode === StatusCodes.FORBIDDEN) {
    errorMessage = `You cannot use this request on AWS S3 ${name}.`;
  } else if (statusCode === StatusCodes.INTERNAL_SERVER_ERROR) {
    errorMessage = `Error happened in the server on AWS S3 ${name}.`;
  }

  return errorMessage;
};
